import { render, staticRenderFns } from "./CAxASCxSocialPt4Page.vue?vue&type=template&id=31e1ba48"
import script from "./CAxASCxSocialPt4Page.vue?vue&type=script&lang=js"
export * from "./CAxASCxSocialPt4Page.vue?vue&type=script&lang=js"
import style0 from "./CAxASCxSocialPt4Page.vue?vue&type=style&index=0&id=31e1ba48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports